import React from "react";
import { Link } from "react-router";
import { performancePath } from "../Components/Templates/MenuHelper";

function WorkspaceModuleNoPermission(props) {

  return (
    <React.Fragment>
      <div className="container" data-testid="workspace-permission-denied">
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        {/* Dark pass 2026-09-09 (re-ink only — same bootstrap markup, no DS migration).
            `.alert-danger` + `.bg-white` painted the light-only look (bg-white is !important,
            so it has to go, not be overridden). The `.alert` box stays; the surface/edge/ink
            tokens carry the ground, the heading keeps the error mark via the danger glyph
            token, and links take the accent token. */}
        <div
          className="alert tw-bg-surface tw-border-edge tw-text-ink"
          role="alert"
          data-testid="workspace-permission-denied-card"
        >
          <h4 className="alert-heading tw-text-tone-danger-glyph" data-testid="workspace-permission-denied-title">Permission Denied!</h4>
          <p className="tw-text-ink-secondary">
            Looks like you don&apos;t have enough permission to access this feature
            or resource.
          </p>
          <hr className="tw-bg-edge tw-opacity-100" />

          <br />
          <p className="mb-0 tw-text-ink-secondary">
            If you are lost , Please click&nbsp;
            {/* Points at the Performance Dashboard: /dashboard was retired 2026-07-30 and would
                otherwise land on the not-found page. Same destination login uses. */}
            <Link
              to={performancePath}
              className="tw-text-accent hover:tw-text-accent-hover"
              style={{ cursor: "pointer" }}
              data-testid="workspace-permission-denied-dashboard-link"
            >
              here
            </Link>
            &nbsp;to go back to the dashboard
          </p>
        </div>
      </div>
    </React.Fragment>
  );
}

export default WorkspaceModuleNoPermission;
